import React from 'react';
import * as PropTypes from 'prop-types';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  // WhatsappShareButton,
  // PinterestShareButton,
  // VKShareButton,
  // OKShareButton,
  RedditShareButton,
  // TumblrShareButton,
  // LivejournalShareButton,
  // MailruShareButton,
  // ViberShareButton,
  // WorkplaceShareButton,
  // LineShareButton,
  // PocketShareButton,
  // InstapaperShareButton,
  EmailShareButton,
} from 'panta-react-share';
import {
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  // WhatsappIcon,
  LinkedinIcon,
  // PinterestIcon,
  // VKIcon,
  // OKIcon,
  RedditIcon,
  // TumblrIcon,
  // LivejournalIcon,
  // MailruIcon,
  // ViberIcon,
  // WorkplaceIcon,
  // LineIcon,
  // PocketIcon,
  InstapaperIcon,
  EmailIcon,
} from 'panta-react-share';
import {
  FacebookShareCount,
  // PinterestShareCount,
  // VKShareCount,
  // OKShareCount,
  RedditShareCount,
  // TumblrShareCount,
} from 'panta-react-share';

import settings from '../../lib/settings';
import { classNamer, classes } from '../../lib/utils';
import R, { externalUrl } from '../../lib/routes';

import './BlogArticleShare.scss';

const cn = classNamer('BlogArticleShare');

const BlogArticleShare = ({ article, className, iconSize = 50 }) => {
  if (!article) {
    return null;
  }

  const url = externalUrl(R.blogArticle(article));

  return (
    <div className={classes(cn(), className)}>
      <div className={cn('item')}>
        <FacebookShareButton url={url} quote={article.title}>
          <FacebookIcon size={iconSize} round={true} />
        </FacebookShareButton>
        <FacebookShareCount accessToken={settings.facebookAppToken} url={url} />
      </div>

      <div className={cn('item')}>
        <TwitterShareButton url={url} title={article.title} hashtags={['xcalibra']}>
          <TwitterIcon size={iconSize} round={true} />
        </TwitterShareButton>
      </div>

      <div className={cn('item')}>
        <LinkedinShareButton url={url}>
          <LinkedinIcon size={iconSize} round={true} />
        </LinkedinShareButton>
      </div>

      <div className={cn('item')}>
        <RedditShareButton url={url} title={article.title}>
          <RedditIcon size={iconSize} round={true} />
        </RedditShareButton>
        <RedditShareCount url={url} />
      </div>

      <div className={cn('item')}>
        <TelegramShareButton url={url} title={article.title}>
          <TelegramIcon size={iconSize} round={true} />
        </TelegramShareButton>
      </div>

      <div className={cn('item')}>
        <EmailShareButton url={url}>
          <EmailIcon size={iconSize} round={true} />
        </EmailShareButton>
      </div>
    </div>
  );
};

BlogArticleShare.propTypes = {
  article: PropTypes.object,
  className: PropTypes.string,
  iconSize: PropTypes.number,
};

export default BlogArticleShare;
